/**
 * v-clickable — torna acessível por teclado um elemento não-botão que já tem @click
 * (card, linha de tabela, área de upload). Não muda o clique: só adiciona foco (Tab)
 * e dispara o mesmo click com Enter/Espaço, além de anunciar como botão.
 * Linhas de tabela (<tr>) mantêm a semântica de linha — ganham só foco e teclado.
 */
function onKeydown(e) {
  if (e.target !== e.currentTarget) return
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault()
    e.currentTarget.click()
  }
}

export const clickable = {
  mounted(el) {
    if (el.tagName !== 'TR' && !el.hasAttribute('role')) el.setAttribute('role', 'button')
    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0')
    el.addEventListener('keydown', onKeydown)
  },
  beforeUnmount(el) {
    el.removeEventListener('keydown', onKeydown)
  },
}
